import React from 'react'
import {
  ContactItem,
  ContactRow,
  CopyRight,
  FooterLogo,
  LandingFooterWrapper,
  RewardDescription,
  RewardItem,
  RewardRow,
  RewardRowWrapper,
  RewardTitle,
} from './LandingFooterBigStyled'
import { Container, ContentWrapper, IconFooter, LogoWrapper } from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import moment from 'moment'
import { contacts } from '../../utils/data'
import { VIEW_MODE } from '../../constant'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import { buildPath, renderImageByBreakPoint } from '../../utils/common'
import config from '../../config'

const LandingFooterBig = props => {
  const { mode, data } = props
  const breakPoint = useRecoilValue(breakPointState)

  const renderFooterBackground = () => {
    if (data?.footerConfig?.default) return IMAGES.FOOTER_BG
    return renderImageByBreakPoint(breakPoint, {
      computer: buildPath(data?.footerConfig?.backgroundImages?.computer),
      tablet: buildPath(data?.footerConfig?.backgroundImages?.tablet),
      mobile: buildPath(data?.footerConfig?.backgroundImages?.mobile),
    })
  }
  return (
    <LandingFooterWrapper backgroundImage={renderFooterBackground()}>
      <Container>
        <ContentWrapper>
          <LogoWrapper>
            <img className={'logo-footer'} src={IMAGES.LOGO_LIGHT} alt={'LOGO_LIGHT'} height={40} />
          </LogoWrapper>
          <RewardRowWrapper>
            <IconFooter src={IMAGES.ICON_FOOTER} alt={'ICON_FOOTER'} />
            <RewardRow>
              <RewardItem>
                <RewardTitle>NGÂN HÀNG HỖ TRỢ DOANH NGHIỆP SIÊU NHỎ TỐT NHẤT NĂM 2020, 2022</RewardTitle>
                <RewardDescription>ASIAN BANKING & FINANCE</RewardDescription>
              </RewardItem>
              <RewardItem>
                <RewardTitle>ỨNG DỤNG NGÂN HÀNG TỐT NHẤT CHO DOANH NGHIỆP SME VÀ MICRO-SME</RewardTitle>
                <RewardDescription>GLOBAL BANKING AND FINANCE REVIEW</RewardDescription>
              </RewardItem>
            </RewardRow>
          </RewardRowWrapper>
          <ContactRow>
            {contacts.map((item, index) => (
              <ContactItem key={index}>
                <img src={item.icon} alt={item.alt} height={20} width={20} />
                <a href={item.href} target={'_blank'}>
                  {item.label}
                </a>
              </ContactItem>
            ))}
          </ContactRow>
          <CopyRight>All rights reserved. Copyright @ {moment().year()} VPBank SME</CopyRight>
        </ContentWrapper>
      </Container>
    </LandingFooterWrapper>
  )
}

LandingFooterBig.propTypes = {}

export default LandingFooterBig
